import {
  PROJECT_COLOR_MENU_ID,
  ProjectColorMenu,
  TEXT_SIZE_MENU_ID,
  TextSizeMenu,
  ToolbarAnchor,
} from '@components/ArtBoard/ArtboardToolbar'
import type { ID, TextSize } from '@octopus-do/octopus-project-core'
import { Toolbar } from '@octopus-do/octopus-storybook'
import { ArrowDown, ArrowUp, Trash } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { createSwitch } from '@/utils'
import { MORE_MENU_ID, MoreMenu } from './components'

interface Props {
  colorId: ID
  disabledDown: boolean
  disabledUp: boolean
  onChangeColor: (colorId: ID) => void
  onChangeTextSize: (textSize: TextSize) => void
  onDelete: () => void
  onDuplicate: () => void
  onMoveDown: () => void
  onMoveUp: () => void
  onPaste: () => void
  // The clipboard is being read and applied after Paste
  pasting: boolean
  scale: number
  textSize: TextSize
  textSizeDisabled: boolean
}

export const SectionToolbar: React.FC<Props> = ({
  colorId,
  disabledDown,
  disabledUp,
  onChangeColor,
  onChangeTextSize,
  onDelete,
  onDuplicate,
  onMoveDown,
  onMoveUp,
  onPaste,
  pasting,
  scale,
  textSize,
  textSizeDisabled,
}) => {
  const switcher = createSwitch()
    .case(['move_up'], onMoveUp)
    .case(['move_down'], onMoveDown)
    .case([PROJECT_COLOR_MENU_ID], onChangeColor)
    // the menu reports TEXT_SIZE_OPTIONS ids, which are TextSize values
    .case([TEXT_SIZE_MENU_ID], (size) => onChangeTextSize(size as TextSize))
    .case([MORE_MENU_ID, 'duplicate'], onDuplicate)
    .case([MORE_MENU_ID, 'paste'], onPaste)
    .case(['delete'], onDelete)

  const onClick = (keys: string[]) => switcher.run(keys)

  return (
    <ToolbarAnchor scale={scale}>
      <Toolbar.Root onClick={onClick}>
        <Toolbar.Button
          disabled={disabledUp}
          icon={ArrowUp}
          id="move_up"
          tooltip="Move up"
        />
        <Toolbar.Button
          disabled={disabledDown}
          icon={ArrowDown}
          id="move_down"
          tooltip="Move down"
        />
        <ProjectColorMenu colorId={colorId} />
        <TextSizeMenu disabled={textSizeDisabled} textSize={textSize} />
        <Toolbar.Divider />
        <MoreMenu pasting={pasting} />
        <Toolbar.Button
          icon={Trash}
          id="delete"
          tooltip="Delete"
          variant="danger"
        />
      </Toolbar.Root>
    </ToolbarAnchor>
  )
}
